import Component from 'vue-class-component'
import Router from 'vue-router'
import Vue from 'vue'
import config from './config'
// Register the router hooks with their names
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteUpdate',
    'beforeRouteLeave'
])
Vue.use(Router)

export default new Router({
    linkActiveClass: 'active',
    mode: 'history',
    base: config.app_name,
    routes: [{
        path: '/bigAlbum',
        meta: {
            topColor: 'black',
            isShowHeader: true
        },
        component: () => import("./pages/bigAlbum/post.vue"),
    }, {
        path: '/albumInfo/:albumId',
        alias: '/albums/:albumId',
        meta: {
            title: '音频播放',
            isShowHeader: false
        },
        component: () => import("./pages/albumInfo2.vue"),
    }, {
        path: '/book/:catId',
        meta: {
            isShowHeader: true
        },
        component: () => import("./pages/booklist.vue"),
    }, {
        path: '/album/:more_id',
        meta: {
            isShowHeader: true
        },
        component: () => import("./pages/getMore.vue"),
    }, {
        path: '/albums/:albumId', // 应该没用了
        meta: {
            isShowHeader: true
        },
        component: () => import("./pages/album.vue"),
    }, {
        path: '/more',
        component: () => import("./pages/getEveryMore.vue"),
    }, {
        path: '/play',
        component: () => import("./pages/player/index.vue"),
        meta: {
            title: '音频播放'
        },
    }, {
        path: '/vip',
        component: () => import("./pages/member/home.vue"),
    }, {
        path: '/vip/cash',
        component: () => import("./pages/member/cash.vue"),
    }, {
        path: '/albumerr',
        component: () => import("./pages/albumErr.vue"),
    }, {
        //     path: '/shareLeaderboard', // 不确定
        //     component: () => import("./pages/h5/shareLeaderboard.vue"),
        //     meta: {
        //         isShowHeader: true
        //     },
        // }, {
        //     path: '/vipContinue',
        //     component: () => import("./pages/h5/vipContinue.vue"),
        // }, {
        //     path: '/vipExplanation',
        //     component: () => import("./pages/h5/vipExplanation.vue"),
        // }, {
        path: '/shareVideo',
        meta: {
            isShowHeader: true
        },
        component: () => import("./pages/h5/shareVideo.vue"),
    }, {
        path: '/shareDub',
        component: () => import("./pages/h5/shareDub.vue"),
        meta: {
            isShowHeader: true
        },
    }, {
        path: '/testOpenApp',
        component: () => import("./pages/openApp.vue"),
    }, {
        path: '*',
        component: () => import("./components/error.vue"),
    }]
})
